import wcActApi from '@/config/wcActApi'

export default {
  namespaced: true,
  state: {
    activityInfo: null,
  },
  mutations: {
    SET_ACTIVITY_INFO(state, info) {
      state.activityInfo = info
    },
  },
  actions: {
    async fetchActivityInfo({ commit }, params) {
      const res = await wcActApi.getActivityInfo(params)
      commit('SET_ACTIVITY_INFO', res)
      return res
    },
  },
  getters: {
    activityInfo: (state) => state.activityInfo,
  },
}
